import { render, staticRenderFns } from "./Tagger.vue?vue&type=template&id=f8d71cf8&"
import script from "./Tagger.vue?vue&type=script&lang=js&"
export * from "./Tagger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports